

















































































import Vue from "vue";
import Loading from "@/components/Loading.vue";
import PaymentProvidersSettings from "@/views/PaymentProvidersSettings.vue";
import Billing from "@/views/Billing.vue";
// import EmailV2 from "@/components/Email/EmailV2.vue";
import { loadSigningKey } from "@/helpers/api";
import { bus } from "@/main";

export default Vue.extend({
  name: "iFrameModal",
  components: { /*EmailV2,*/ Billing, PaymentProvidersSettings, Loading },
  props: {
    url: { type: String },
    show: { type: Boolean },
    title: { type: String, default: "" },
    callback: { type: Function },
    emailIds: { type: Array, default: () => [] as string[] },
    eventIds: { type: Array, default: () => [] as string[] },
    width: { type: Number, default: 1024 },
    height: { type: Number, default: 800 },
    fullscreen: { type: Boolean, default: true }
  },
  data() {
    return {
      loading: true,
      signingKey: null as null | string
    };
  },
  methods: {
    closeModal() {
      if (this.callback) {
        this.callback();
      }
      this.$emit("close");
    },
    async setSigningKey() {
      const resp = await loadSigningKey();
      const key = JSON.parse(resp.data.key);
      key.params.AWSAccessKeyId = key.params.policy;
      key.params.signature = key.params["x-amz-signature"];
      this.signingKey = key;
    }
  },
  watch: {
    // url: {
    //   handler: function() {
    //     this.loading = true;
    //     console.log(this.url);
    //     if (this.url === "email-teams" || this.url === "email-event") {
    //       if (this.emailIds.length === 0 && this.eventIds.length === 0) {
    //         this.closeModal();
    //         return;
    //       }
    //       this.setSigningKey();
    //     }
    //   },
    //   immediate: true
    // }
    url() {
      this.loading = true;
      if (this.url === "email-teams") {
        setTimeout(() => {
          this.loading = true;
          const el = document.getElementById("email-form");
          if (this.emailIds?.length == 0) {
            this.closeModal();
            bus.$emit(
              "errorSnack",
              "Please select at least one team to send email to."
            );
            return;
          }
          if (el) {
            //@ts-ignore
            el.submit();
            //@ts-ignore
            el.reset();
          }
        }, 2000);
      }
    }
  }
});
